import { ResSavedFilter } from '@/models/users'

export interface SavedFiltersState {
  filters: ResSavedFilter[]
  newFilter: ResSavedFilter | ''
}

export const initialState: SavedFiltersState = {
  filters: [],
  newFilter: ''
}
